import { render, staticRenderFns } from "./lookTbwj.vue?vue&type=template&id=136ca33b&scoped=true"
import script from "./lookTbwj.vue?vue&type=script&lang=js"
export * from "./lookTbwj.vue?vue&type=script&lang=js"
import style0 from "./lookTbwj.vue?vue&type=style&index=0&id=136ca33b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ca33b",
  null
  
)

export default component.exports